var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83518 10.95C7.02144 10.7627 7.12598 10.5092 7.12598 10.245C7.12598 9.98084 7.02144 9.72738 6.83518 9.54002L3.29518 5.95002L6.83518 2.41002C7.02144 2.22266 7.12598 1.96921 7.12598 1.70502C7.12598 1.44084 7.02144 1.18738 6.83518 1.00002C6.74222 0.906294 6.63162 0.831899 6.50976 0.78113C6.3879 0.730362 6.2572 0.704224 6.12518 0.704224C5.99317 0.704224 5.86247 0.730362 5.74061 0.78113C5.61875 0.831899 5.50815 0.906294 5.41518 1.00002L1.17518 5.24002C1.08146 5.33298 1.00706 5.44359 0.956293 5.56544C0.905524 5.6873 0.879386 5.81801 0.879386 5.95002C0.879386 6.08203 0.905524 6.21274 0.956293 6.3346C1.00706 6.45646 1.08146 6.56706 1.17518 6.66002L5.41518 10.95C5.50815 11.0437 5.61875 11.1181 5.74061 11.1689C5.86247 11.2197 5.99317 11.2458 6.12518 11.2458C6.2572 11.2458 6.3879 11.2197 6.50976 11.1689C6.63162 11.1181 6.74222 11.0437 6.83518 10.95Z",
    fill: "#000348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.df4aa4f39ff8f34f917cd112e7fe99f9.svg";
export { ForwardRef as ReactComponent };